import { supabase } from "./supabase.client";

export interface Profile {
	id: string;
	first_name: string | null;
	last_name: string | null;
	email: string | null;
}

export async function getMyProfile(): Promise<Profile | null> {
	const {
		data: { user },
	} = await supabase.auth.getUser();
	if (!user) return null;
	const { data, error } = await supabase
		.from("profiles")
		.select("id,first_name,last_name,email")
		.eq("id", user.id)
		.maybeSingle();
	if (error) throw new Error(error.message);
	return (data as Profile | null) ?? null;
}

export async function updateMyProfile(patch: {
	first_name?: string;
	last_name?: string;
}): Promise<Profile> {
	const {
		data: { user },
	} = await supabase.auth.getUser();
	if (!user) throw new Error("Not authenticated");
	const { data, error } = await supabase
		.from("profiles")
		.update(patch)
		.eq("id", user.id)
		.select()
		.single();
	if (error) throw new Error(error.message);
	// Also update auth metadata so handle_new_user stays in sync with user_metadata
	await supabase.auth.updateUser({
		data: { first_name: patch.first_name, last_name: patch.last_name },
	});
	return data as Profile;
}
